module.exports = __webpack_public_path__ + "static/img/PARIS_MAPLE.fe43fed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/PARIS_MAPLE.jpg
// module id = XT2s
// module chunks = 0